module.exports = __webpack_public_path__ + "img/pressure.84e20589.svg";